export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "open-sidebar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ouvrir le panneau"])}
      },
      "en": {
        "open-sidebar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Open sidebar"])}
      }
    }
  })
}
